module.exports = __webpack_public_path__ + "media/images/color_admin_v3/user-11-b588b158ae62381ffec4bd25b1ae9540.jpg";